export const PRODUCT_MODEL_SLIDER_FACET_ID = 5;
export const PRODUCT_MODEL_SLIDER_FACET_ID_US = 23;
export const NUMBER_OF_PRODUCTS_PER_PAGE = 10;

// should be something like ten, but
// is not working properly with reduced facets (counting wrong)
export const MINIMUM_NUMBER_OF_PROPERTIES_TO_COLLAPSE = 999;

export const MAX_SHEETS = 20;

export const ANIMATION_DURATION = 300;
